import { render, staticRenderFns } from "./threeEcharts.vue?vue&type=template&id=2ae3a4fb&"
import script from "./threeEcharts.vue?vue&type=script&lang=js&"
export * from "./threeEcharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports